export const _isComponent = (tab) => tab.hasOwnProperty('component')

const parseCondition = (tab, state, getters) => _.has(tab, 'display_condition') ?
  tab.display_condition(state, getters) : true

const parseTab = (h, tab) => _isComponent(tab) ?
  <tab.component></tab.component> : <router-view name={tab.name}></router-view>


const TabContentWrapper = {
  functional: true,

  name: "TabContentWrapper",

  props: {
    tabs: {
      type: Array,
      required: true
    },

    activeTab: {
      type: Number,
      required: true
    },
  },

  render(h, context) {
    const props = context.props,
      tabs = props.tabs,
      activeTabIdx = props.activeTab,
      store = context.parent.$store,
      state = store.state,
      getters = store.getters,
      activeTab = _.find(tabs, (tab, idx) => idx === activeTabIdx),
      content = activeTab && parseCondition(activeTab, state, getters) && parseTab(h, activeTab)

    return (
      <div class="tab-content" style="overflow: visible;">
        {content || ""}
      </div>
    )
  }
}

export default TabContentWrapper



// WEBPACK FOOTER //
// ./client/components/Tabs/TabContentWrapper.js